import { render } from "./LoginArea.vue?vue&type=template&id=648a7d67"
import script from "./LoginArea.vue?vue&type=script&lang=js"
export * from "./LoginArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__